import React, { useEffect, useState } from "react";

import { getAuth } from "firebase/auth";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

export default function Home() {
  const auth = getAuth();

  const tenantId = getTenantIdFromHost();

  const [headerLogo, setHeaderLogo] = useState("/kundresa_logo.png");

  const isSignedIn = !!auth.currentUser;

  return (
    <div className="publicPage">
      <div className="publicHeader">
        <div className="titleWrapper">
          {tenantId ? (
            // <img
            //   className="indexLogo"
            //   src={`/logos/${tenantId}_logo.png`}
            //   alt={`${tenantId} logo`}
            // />
            <img
              className="indexLogo"
              src={headerLogo}
              alt={`${tenantId} logo`}
            />
          ) : (
            <img
              className="indexLogo"
              src={"/kundresa_logo.png"}
              alt="Kundupplevelse logo"
            />
          )}
          <a
            href="/login"
            className={"headerLink"}
          >
            Admin
          </a>
          <h1>Kundupplevelse - Enkät & Kundportal</h1>
        </div>
      </div>
      <div className="devider50"></div>
      <div className="visualizeWrapper transpWrapp">
        <div className="landingContent">
          <h3 className="heroSlogan">
            Lyssna · Förstå · Förbättra
            <br />
            Insikter som gör kundupplevelsen bättre.
          </h3>

          <h1>Följ upp kundupplevelsen – enkelt och personligt</h1>

          <p className="lead">
            Skicka ut en kort enkät via SMS eller e-post och få värdefull
            återkoppling från dina kunder.
          </p>

          <p>
            Kundupplevelse gör det enkelt att följa upp varje ärende – med
            personlig kontakt, tydlig överblick och trygg hantering av data.
          </p>

          <ul className="features">
            <li>✔ Skicka enkäter via SMS eller e-post </li>
            <li>✔ Se vad som har skickats – och när</li>
            <li>✔ Följ upp svar och återkoppling</li>
            <li>✔ Enkel och personlig kommunikation</li>
          </ul>

          <div className="cta">
            <p>Vill du se hur det fungerar i praktiken?</p>
            <a className="ctaBtn" href="mailto:jenni@kundupplevelse.com">
              Kontakta oss via e-post
            </a>
          </div>

          <hr />
          {/* <p>
            <a className="smallLink" href="/privacy">
              Integritetspolicy
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
}
